import type {IFormFieldV2} from 'src/types/FormV2';

// A rule or filter compares against one option, so a multi-select target
// renders as its single-select twin.
export const toSingleValueField = (field: IFormFieldV2): IFormFieldV2 =>
  field.type === 'select-multiple' ? {...field, type: 'select'} : field;
